export default "__VITE_ASSET__Iegq2HjU__"